<hr>
<div class="content">
  <h3>File Reviews</h3>
<p>Review based on Automated Standards Document</p>

<mat-grid-list cols="5" rowHeight="50px" gutterSize="10px">
  <mat-grid-tile *ngFor="let file of files" class="file-tile">
    <div class="file-content">
      <span class="file-name">{{ file.name }}</span>
      <span class="file-icon">
        <app-icon icon="open_with" (click)="openMappingDialog()" (keydown.enter)="openMappingDialog()"  [customStyle]="{fontSize: '14px', color: '#97C382', cursor: 'pointer'}"></app-icon>
      </span>
    </div>
  </mat-grid-tile>
</mat-grid-list>

<p>Test Automation Script Reviews</p>

<mat-grid-list cols="5" rowHeight="50px" gutterSize="10px">
  <mat-grid-tile *ngFor="let file of files" class="file-tile">
    <div class="file-content">
      <span class="file-name">{{ file.name }}</span>
      <span class="file-icon">
        <app-icon icon="open_with" (click)="openMappingDialog()" (keydown.enter)="openMappingDialog()" [customStyle]="{fontSize: '14px', color: '#97C382', cursor: 'pointer'}"></app-icon>
      </span>
    </div>
  </mat-grid-tile>
</mat-grid-list>

</div>
